import React, { useState, useEffect } from "react";
import {  BrowserRouter as Router,  Routes,  Route,  Navigate,  useLocation,  useNavigate,} from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import ItemsPage from "./components/ItemsPage";
import Orderdetails from "./components/Orderdetails";
import PaymentApproval from "./components/PaymentApproval";
import VerifyCustomers from "./components/VerifyCustomers";
import OrderSummary from "./components/OrderSummary";

import OrderForm from "./components/OrderForm";
import OrderFormExplorer from "./components/OrderFormExplorer";
import OrderProcess from "./components/OrderProcess";
import ReceiptUpload from "./components/ReceiptUpload";

import DeliveryAllotment from "./components/DeliveryAllotment";
import DeliveryUpdate from "./components/DeliveryUpdate";

import CustomerExplr from "./components/CustomerExplr";
import CustomerMaster from "./components/CustomerMaster";
import OrderandPayment from "./components/OrderandPayment";
import OrderRatingsFeedBack from "./components/OrderRatingsFeedBack";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // ✅ Check login status for this session
  useEffect(() => {
    const storedLogin = sessionStorage.getItem("isLoggedIn");
    setIsLoggedIn(storedLogin === "true");
  }, []);

  return (
    <Router>
      <RouteTracker isLoggedIn={isLoggedIn} />
      <Routes>
        {/* ✅ Login Page */}
        <Route
          path="/"
          element={
            isLoggedIn ? (
              <Navigate to={sessionStorage.getItem("lastVisited") || "/dashboard"} replace />
            ) : (
              <Login setIsLoggedIn={setIsLoggedIn} />
            )
          }
        />

        {/* ✅ Protected Routes */}
        <Route
          path="/dashboard"
          element={
            isLoggedIn ? (
              <Dashboard setIsLoggedIn={setIsLoggedIn} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        <Route
          path="/items"
          element={isLoggedIn ? <ItemsPage /> : <Navigate to="/" replace />}
        />

        <Route
          path="/orderdetails"
          element={isLoggedIn ? <Orderdetails /> : <Navigate to="/" replace />}
        />

        <Route
          path="/paymentapproval"
          element={isLoggedIn ? <PaymentApproval /> : <Navigate to="/" replace />}
        />

           <Route
          path="/verifycustomers"
          element={isLoggedIn ? <VerifyCustomers /> : <Navigate to="/" replace />}
        />

            <Route
          path="/ordersummary"
          element={isLoggedIn ? <OrderSummary /> : <Navigate to="/" replace />}
        />

            <Route
          path="/orderformexplorer"
          element={isLoggedIn ? <OrderFormExplorer /> : <Navigate to="/" replace />}
        />

            <Route
           path="/orderform"
           element={isLoggedIn ? <OrderForm /> : <Navigate to="/" replace />}
         />

            <Route
           path="/orderprocess"
           element={isLoggedIn ? <OrderProcess setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/" replace />}
         />

            <Route
           path="/receiptupload"
           element={isLoggedIn ? <ReceiptUpload setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/" replace />}
         />

             <Route
          path="/deliveryallotment"
          element={isLoggedIn ? <DeliveryAllotment /> : <Navigate to="/" replace />}
        />

        <Route
          path="/deliveryupdate"
          element={isLoggedIn ? <DeliveryUpdate /> : <Navigate to="/" replace />}
        />

         <Route
          path="/CustomerExplr"
          element={isLoggedIn ? <CustomerExplr /> : <Navigate to="/" replace />}
        />
        <Route
          path="/customers/new"
          element={isLoggedIn ? <CustomerMaster /> : <Navigate to="/" replace />}
        />
        <Route
          path="/customers/edit/:id"
          element={isLoggedIn ? <CustomerMaster /> : <Navigate to="/" replace />}
        />

        <Route
          path="/orderandpayment"
          element={isLoggedIn ? <OrderandPayment /> : <Navigate to="/" replace />}
        />

   <Route
          path="/orderRatings"
          element={isLoggedIn ? <OrderRatingsFeedBack /> : <Navigate to="/" replace />}
        />

         <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;

/* ✅ RouteTracker Component — remembers last page during session */
function RouteTracker({ isLoggedIn }) {
  const location = useLocation();
  const navigate = useNavigate();

  // 🔹 Save current route in sessionStorage whenever it changes
  useEffect(() => {
    if (location.pathname !== "/" && isLoggedIn) {
      sessionStorage.setItem("lastVisited", location.pathname);
    }
  }, [location, isLoggedIn]);

  // 🔹 Restore last visited route after refresh
  useEffect(() => {
    const lastVisited = sessionStorage.getItem("lastVisited");
    if (isLoggedIn && lastVisited && window.location.pathname === "/") {
      navigate(lastVisited, { replace: true });
    }
  }, [isLoggedIn, navigate]);

  return null;
}




// import React, { useState, useEffect } from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
//   useLocation,
//   useNavigate,
// } from "react-router-dom";
// import Login from "./components/Login";
// import Dashboard from "./components/Dashboard";
// import ItemsPage from "./components/ItemsPage";
// import Orderdetails from "./components/Orderdetails";
// import PaymentApproval from "./components/PaymentApproval";

// function App() {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   // ✅ Check login status when app loads
//   useEffect(() => {
//     const storedLogin = localStorage.getItem("isLoggedIn");
//     setIsLoggedIn(storedLogin === "true");
//   }, []);

//   return (
//     <Router>
//       <RouteTracker isLoggedIn={isLoggedIn} /> {/* ✅ Keeps track of last visited route */}
//       <Routes>
//         {/* ✅ Login Page */}
//         <Route
//           path="/"
//           element={
//             isLoggedIn ? (
//               <Navigate to="/dashboard" replace /> // Always go to Dashboard after login
//             ) : (
//               <Login setIsLoggedIn={setIsLoggedIn} />
//             )
//           }
//         />

//         {/* ✅ Protected Routes */}
//         <Route
//           path="/dashboard"
//           element={
//             isLoggedIn ? <Dashboard setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/" replace />
//           }
//         />

//         <Route
//           path="/items"
//           element={isLoggedIn ? <ItemsPage /> : <Navigate to="/" replace />}
//         />

//         <Route
//           path="/orderdetails"
//           element={isLoggedIn ? <Orderdetails /> : <Navigate to="/" replace />}
//         />

//         <Route
//           path="/paymentapproval"
//           element={isLoggedIn ? <PaymentApproval /> : <Navigate to="/" replace />}
//         />

//         {/* ✅ Catch-All Redirect */}
//         <Route path="*" element={<Navigate to="/" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// /* ✅ RouteTracker Component — saves last visited route for refresh */
// function RouteTracker({ isLoggedIn }) {
//   const location = useLocation();
//   const navigate = useNavigate();

//   // 🔹 Save current route in localStorage when it changes (except "/")
//   useEffect(() => {
//     if (location.pathname !== "/" && isLoggedIn) {
//       localStorage.setItem("lastVisited", location.pathname);
//     }
//   }, [location, isLoggedIn]);

//   // 🔹 Restore last visited route only on refresh if logged in
//   useEffect(() => {
//     const lastVisited = localStorage.getItem("lastVisited");
//     if (isLoggedIn && lastVisited && window.location.pathname === "/") {
//       navigate(lastVisited, { replace: true });
//     }
//   }, [isLoggedIn, navigate]);

//   return null;
// }


